/**
 * Commerce Page Init
 *
 * @module
 */

import { $$ } from '../../utilities/QuerySelectors.js';

/**
 * Entry point for enhancements to the commerce templates.
 *
 * 1) Deferred init for country / district selector.
 * 2) Commerce footer CSS class.
 * 3) Light caption for dark background returns tables.
 * 4) Alignment fix for returns company / logo widget.
 * 5) Add padding to footer only if there is visible content.
 *
 * @return {void}
 */
export function init() {
    if ('initOrderFormCountrySelector' in window) {
        // @ts-ignore: initOrderFormCountrySelector is in window, check views/Commerce/orderForm.html.twig
        window.initOrderFormCountrySelector();
    }

    const footer = document.querySelector('.order-page-bottom');
    if (footer) {
        footer.classList.add('first-order-footer');
        // @ts-ignore: cannot easily cast to HTMLElement.
        if (footer.offsetHeight > 0) {
            footer.classList.add('has-visible-content');
        }
    }

    document.querySelector('.portfolio-returns-table ~ .caption_1')?.removeAttribute('style');

    $$('.dynamic-rec-returns').forEach(div => div.parentElement.style.textAlign = 'center');

    $$('#marketing-page-container')
        .filter(div => div.children.length === 0)
        .forEach(div => div.remove());
}
